import {
  setActiveTabSlice,
  setActiveSubTabSlice,
} from '../slices/superadmin.slice';

export const setActiveTabAction = (tab) => (dispatch) => {
  dispatch(setActiveTabSlice(tab));
};

export const setActiveSubTabAction = (subTab) => (dispatch) => {
  dispatch(setActiveSubTabSlice(subTab));
};
